import { ScanningSessionFlow } from "./scanning-session-repository";

export class PreviousScanningSession {
    private readonly _locatorsList: string[];
    private readonly _type: Exclude<ScanningSessionFlow, "unknown">;
    private readonly _warehouseCode: string;

    constructor(locatorsList: string[], type: Exclude<ScanningSessionFlow, "unknown">, warehouseCode: string) {
        this._locatorsList = locatorsList;
        this._type = type;
        this._warehouseCode = warehouseCode;
    }

    get locatorsList(): string[] {
        return this._locatorsList;
    }

    get type() {
        return this._type;
    }

    public hasScannedValuesFor(warehouseCode: string) {
        return this._locatorsList.length > 2 && this._warehouseCode === warehouseCode;
    }
}
